// extracted by mini-css-extract-plugin
module.exports = {"application":"application__u2ivc","applicationTitle":"applicationTitle__1bC6n","content":"content__3EBME"};